import { IError } from './interfaces';
import store from '../store/store';
import types from '../store/types';

export class ErrorHelper {

	public static raiseError(error: IError) {
		store.dispatch({
			type: types.RAISE_ERROR,
			error: error
		});
	}

}


// WEBPACK FOOTER //
// ./source/ts/helpers/error.ts